import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { AlertCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const UsernameWarningBanner: React.FC = () => {
    const { isLoggedIn, currentUser } = useAuth();

    // Ha nincs bejelentkezve, ne jelezzünk semmit
    if (!isLoggedIn || !currentUser) {
        return null;
    }

    // Ellenőrizzük az username hosszát (20 karakter a limit)
    const isUsernameTooLong = currentUser.name && currentUser.name.length > 20;
    const isUsernameEmpty = !currentUser.name;

    // Ha nincs sem hiba, ne jelezzünk semmit
    if (!isUsernameTooLong && !isUsernameEmpty) {
        return null;
    }

    let title = '';
    let message = '';
    let bgColor = 'bg-yellow-400';
    let borderColor = 'border-yellow-600';
    let textColor = 'text-yellow-900';
    let bgColorText = 'text-yellow-800';
    let buttonBg = 'bg-yellow-600 hover:bg-yellow-700';

    if (isUsernameTooLong) {
        title = 'Felhasználónév túl hosszú!';
        message = 'A felhasználóneved 20 karakternél hosszabb. Kérjük, rövidítsd meg a beállításoknál!';
        bgColor = 'bg-red-400';
        borderColor = 'border-red-600';
        textColor = 'text-red-900';
        bgColorText = 'text-red-800';
        buttonBg = 'bg-red-600 hover:bg-red-700';
    } else if (isUsernameEmpty) {
        title = 'Felhasználónév szükséges';
        message = 'Add meg a felhasználóneved a beállításoknál, hogy használhass minden funkciót!';
    }

    return (
        <div className={`${bgColor} border-b-2 ${borderColor} py-3 px-4 shadow-md sticky top-0 z-40`}>
            <div className="container mx-auto flex items-center justify-between gap-4">
                <div className="flex items-center gap-3 flex-grow">
                    <AlertCircle className={`h-6 w-6 ${textColor} flex-shrink-0`} />
                    <div>
                        <p className={`font-bold ${textColor} text-lg`}>{title}</p>
                        <p className={`${bgColorText} text-sm`}>{message}</p>
                    </div>
                </div>
                <Link
                    to="/settings"
                    className={`flex items-center gap-2 ${buttonBg} text-white font-bold py-2 px-4 rounded-md transition-colors whitespace-nowrap flex-shrink-0`}
                >
                    Beállítások
                    <ArrowRight className="h-4 w-4" />
                </Link>
            </div>
        </div>
    );
};

export default UsernameWarningBanner;

